import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
  ArrowLeftIcon,
  ArrowPathIcon,
  EnvelopeIcon,
  GlobeAltIcon,
  MapPinIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";
import {
  clearCurrentSponsor,
  fetchSponsorPublicById,
} from "../../features/admin/SponsorSlice";

const getMediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `${process.env.REACT_APP_API_URL}media/${url}`;
};

const SponsorDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { currentSponsor, detailStatus, detailError } = useSelector(
    (state) => state.sponsors,
  );

  useEffect(() => {
    dispatch(fetchSponsorPublicById(id));

    return () => {
      dispatch(clearCurrentSponsor());
    };
  }, [dispatch, id]);

  if (detailStatus === "loading") {
    return (
      <div className="min-h-[50vh] flex items-center justify-center">
        <ArrowPathIcon className="w-8 h-8 animate-spin text-blue-500" />
      </div>
    );
  }

  if (detailStatus === "failed") {
    return (
      <div className="container mx-auto max-w-[1000px] px-4 pt-5 pb-10">
        <Link
          to="/nha-tai-tro"
          className="btn btn-outline btn-md min-h-11 h-11 px-5 mb-4"
        >
          <ArrowLeftIcon className="w-5 h-5" />
          Quay lại
        </Link>
        <div className="p-4 text-red-500 bg-red-50 rounded-md">
          Đã xảy ra lỗi: {detailError?.messages || "Không thể tải nhà tài trợ"}
        </div>
      </div>
    );
  }

  if (!currentSponsor) return null;

  return (
    <main className="bg-white">
      <section className="container mx-auto pt-5 pb-10">
        {/* <Link to="/nha-tai-tro" className="btn btn-outline btn-md min-h-11 h-11 px-5 mb-6">
          <ArrowLeftIcon className="w-5 h-5" />
          Quay lại danh sách
        </Link> */}

        <div className="bg-white border border-gray-100 rounded-xl shadow-sm overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-[280px_1fr] gap-0">
            <div className="bg-[#fafafa] p-8 flex items-center justify-center min-h-[260px]">
              {currentSponsor.logo ? (
                <img
                  src={getMediaUrl(currentSponsor.logo)}
                  alt={currentSponsor.name}
                  className="max-w-full max-h-48 object-contain"
                />
              ) : (
                <span className="text-gray-400">Chưa có logo</span>
              )}
            </div>

            <div className="p-6 md:p-8">
              <p className="uppercase tracking-[0.12em] text-sm text-primary font-bold">
                Nhà tài trợ
              </p>
              <h1 className="text-3xl font-bold mt-3">{currentSponsor.name}</h1>

              {currentSponsor.businessField && (
                <div className="mt-4 p-4 bg-[#fafafa] rounded-lg border border-gray-100">
                  <h2 className="font-semibold mb-2">Ngành nghề / lĩnh vực</h2>
                  <p className="text-gray-700 whitespace-pre-line">
                    {currentSponsor.businessField}
                  </p>
                </div>
              )}

              <div className="mt-5 space-y-3 text-gray-700">
                {currentSponsor.phoneNumber && (
                  <p className="flex gap-3">
                    <PhoneIcon className="w-5 h-5 text-primary shrink-0" />
                    <span>{currentSponsor.phoneNumber}</span>
                  </p>
                )}
                {currentSponsor.email && (
                  <p className="flex gap-3">
                    <EnvelopeIcon className="w-5 h-5 text-primary shrink-0" />
                    <a
                      href={`mailto:${currentSponsor.email}`}
                      className="hover:text-primary break-all"
                    >
                      {currentSponsor.email}
                    </a>
                  </p>
                )}
                {currentSponsor.website && (
                  <p className="flex gap-3">
                    <GlobeAltIcon className="w-5 h-5 text-primary shrink-0" />
                    <a
                      href={currentSponsor.website}
                      target="_blank"
                      rel="noreferrer"
                      className="hover:text-primary break-all"
                    >
                      {currentSponsor.website}
                    </a>
                  </p>
                )}
                {currentSponsor.address && (
                  <p className="flex gap-3">
                    <MapPinIcon className="w-5 h-5 text-primary shrink-0" />
                    <span>{currentSponsor.address}</span>
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>

        {currentSponsor.content && (
          <article className="mt-8 bg-white border border-gray-100 rounded-xl shadow-sm p-6 md:p-8">
            <h2 className="text-2xl font-bold mb-5">Giới thiệu</h2>
            <div
              className="prose max-w-none"
              dangerouslySetInnerHTML={{ __html: currentSponsor.content }}
            />
          </article>
        )}
      </section>
    </main>
  );
};

export default SponsorDetail;
